
const CarVolunteerPage = () => import("../../views/protocol/carVolunteerProtocolPage.vue");
const VolunteerPage = () => import("../../views/protocol/volunteerProtocolPage.vue");
const RescueProtocolPage = () => import("../../views/protocol/rescueProtocolPage.vue");
const UserProtocolPage = () => import("../../views/protocol/userProtocolPage.vue");


const Container = {
    template: `
    <div style="height: 100%">
      <router-view></router-view>
    </div>
  `,
};

const router = {
    path: '/protocol',
    name: 'protocolContainer',
    component: Container,
    children:[
        {
            path: '/carVolunteer',
            name: 'CarVolunteerPage',
            component: CarVolunteerPage
        },
        {
            path: '/volunteerProtocol',
            name: 'VolunteerPage',
            component: VolunteerPage
        },
        {
            path: '/rescueProtocol',
            name: 'RescueProtocolPage',
            component: RescueProtocolPage
        },
        {
            path: '/userProtocol',
            name: 'UserProtocolPage',
            component: UserProtocolPage
        },
    ]

}

export default router;


// WEBPACK FOOTER //
// ./src/router/modules/protocol.js